import React, { useEffect } from "react";
import { IntlProvider } from "react-intl";
import { CssBaseline } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  selectLanguage,
  setLanguage,
} from "@/redux/features/Setting/Language/languageSlice";
import { getLocalStore } from "@/utils/Session";
import ISystemSetting from "@/interfaces/SliceType/ISystemSetting";
import ThemeCustomization from "@/themes";
import useRoutes from "./useHooks/useRoutes";

const App = () => {

  const dispatch = useAppDispatch();

  const systemLanguage = useAppSelector(selectLanguage);

  const routes = useRoutes();

  const setting = getLocalStore("setting") as ISystemSetting;

  useEffect(() => {
    if (setting) {
      if (setting.language) {
        dispatch(setLanguage(setting.language));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setting, systemLanguage]);

  return (
    <ThemeCustomization>
      <IntlProvider
        locale={systemLanguage.language}
        messages={systemLanguage.messages}
      >
        <CssBaseline />
        {routes}
      </IntlProvider>
    </ThemeCustomization>
  );
};

export default App;
